document.addEventListener("DOMContentLoaded", () => {
  const hiddenLeft = document.querySelector(
    ".ep__what-customers-are-saying-hidden-controls .glide__arrow--left"
  );
  const hiddenRigth = document.querySelector(
    ".ep__what-customers-are-saying-hidden-controls .glide__arrow--right"
  );
  const visibleLeft = document.querySelector(
    ".ep__what-customers-are-saying-glide-controlls button.left"
  );
  const visibleRight = document.querySelector(
    ".ep__what-customers-are-saying-glide-controlls button.right"
  );
  const whatCustomersSay_loadingBar = document.querySelector(
    ".ep__what-customers-are-saying-loading-bar-inside"
  );
  const whatCustomersSay_allSlides = Array.from(
    document.querySelectorAll(
      ".ep__what-customers-are-saying-glide .glide__slide"
    )
  ).length;
  const customerReviews_glide = new Glide(
    ".ep__what-customers-are-saying-glide",
    {
      perView: 3,
      bound: true,
      gap: 24,
      breakpoints: {
        992: {
          perView: 2,
        },
        768: {
          perView: 1,
        },
      },
    }
  );
  customerReviews_glide.on("mount.after", function () {
    visibleLeft.addEventListener("click", () => {
      hiddenLeft.click();
    });
    visibleRight.addEventListener("click", () => {
      hiddenRigth.click();
    });
  });

  customerReviews_glide.on("run", function () {
    const percentage =
      ((customerReviews_glide.index + 1) * 100) / whatCustomersSay_allSlides;
    whatCustomersSay_loadingBar.style.width = `${percentage}%`;
  });

  customerReviews_glide.mount();
});
